import { fabric } from 'fabric'

// ----------------------------------------------------------------------------
// Extend Fabric.js

// console.log('Controls',fabric.Object.prototype.controls)

// Customize object serialization
fabric.Object.prototype.toObject = (function (toObject) {
  return function (propertiesToInclude) {
    propertiesToInclude = (propertiesToInclude || []).concat([
      'id',
      'objectType',
      'resolution',
      'originalSource',
      '_controlsVisibility',
      'selectable',
      'evented'
    ])
    return toObject.call(this, propertiesToInclude)
  }
})(fabric.Object.prototype.toObject)

fabric.Object.prototype.lockScalingFlip = true;
fabric.ActiveSelection.prototype.originX = 'center';
fabric.ActiveSelection.prototype.originY = 'center';

// Customize object controls
fabric.util.object.extend(fabric.Object.prototype, {
  transparentCorners: false,

  cornerColor: '#617cff', // Color of controlling corners of an object
  cornerStrokeColor: '#617cff', // Color of controlling corners of an object
  cornerStyle: 'circle', // Specify style of control, 'rect' or 'circle'
  cornerSize: 10, // Size of object's controlling corners (in pixels), default 13

  // borderDashArray: [8, 8], // Border dash array specification
  borderColor: '#617cff', // Color of controlling borders of an object
  borderScaleFactor: 4, // Factor for controlling borders
  borderOpacityWhenMoving: 0.4, // Opacity of border when object is moving
})

// Custom control visibility for specific objects
// @NOTE: The line shape object also has different controls, these are kept by adding '_controlsVisibility'
// to propertiesToInclude because it is not a separate Class. @TODO: This should be checked
fabric.IText.prototype._controlsVisibility = {
  tl: true, // Top left
  tr: true,  // Top right
  br: true,  // Bottom right
  bl: true,  // Bottom left
  ml: false, // Middle left
  mt: false,  // Middle top
  mr: false, // Middle right
  mb: false, // Middle bottom
  mtr: true  // Rotation control
}

fabric.Image.prototype._controlsVisibility = {
  tl: true, // Top left
  tr: true,  // Top right
  br: true,  // Bottom right
  bl: true,  // Bottom left
  ml: false, // Middle left
  mt: false,  // Middle top
  mr: false, // Middle right
  mb: false, // Middle bottom
  mtr: true  // Rotation control
}

fabric.Group.prototype._controlsVisibility = {
  tl: true, // Top left
  tr: true,  // Top right
  br: true,  // Bottom right
  bl: true,  // Bottom left
  ml: false, // Middle left
  mt: false,  // Middle top
  mr: false, // Middle right
  mb: false, // Middle bottom
  mtr: true  // Rotation control
}


// ----------------------------------------------------------------------------

export default {
  install: (app) => {
    app.provide('fabric', fabric);
  }
};
